export function normalizeDemandPage(value: unknown) {
  if (!value || typeof value !== 'object') return value;
  const record = value as Record<string, unknown>;
  const page = record['page'];
  if (record['totalElements'] === undefined && page && typeof page === 'object')
    return { ...record, totalElements: (page as Record<string, unknown>)['totalElements'] };
  return value;
}
